export const currencyList = [
  {
    label: "USD",
    value: "USD",
  },
  {
    label: "EUR",
    value: "EUR",
  },
  {
    label: "GBP",
    value: "GBP",
  },
  {
    label: "INR",
    value: "INR",
  },
  {
    label: "AED",
    value: "AED",
  },
  {
    label: "SAR",
    value: "SAR",
  },
  {
    label: "AUD",
    value: "AUD",
  },
  {
    label: "NZD",
    value: "NZD",
  },
  {
    label: "BDT",
    value: "BDT",
  },
  {
    label: "PHP",
    value: "PHP",
  },
  {
    label: "SGD",
    value: "SGD",
  },
  {
    label: "CAD",
    value: "CAD",
  },
  {
    label: "COP",
    value: "COP",
  },
  {
    label: "MXN",
    value: "MXN",
  },
  {
    label: "ARS",
    value: "ARS",
  },
];

export const tripTypeList = [
  { label: "One-way", value: "ONE_WAY" },
  { label: "Round-trip", value: "ROUND_TRIP" },
  { label: "Open-jaw", value: "OPEN_JAW" },
  { label: "Other", value: "OTHER" },
  { label: "Any", value: "ANY" },
];

export const cabinClassList = [
  { value: "ECONOMY", label: "Economy" },
  { value: "PREMIUM", label: "Premium Economy" },
  { value: "BUSINESS", label: "Business" },
  { value: "FIRST", label: "First" },
  { value: "ANY", label: "Any" },
];

export const cabinClassMatchModeList = [
  { value: "LONGEST_SEGMENTS", label: "Longest Segments" },
  { value: "ALL_SEGMENTS", label: "All Segments" },
  { value: "ANY_SEGMENT", label: "Any Segment" },
];

export const passengerTypeList = [
  { value: "CHILD", label: "Child" },
  { value: "ANY", label: "Any" },
];

export const interlineList = [
  { value: "DEFAULT", label: "Default" },
  { value: "true", label: "True" },
  { value: "false", label: "False" },
];

export const priceSourceList = [
  { value: "GDS", label: "GDS" },
  { value: "WEBSITE", label: "Website" },
  { value: "ANY", label: "Any" },
];

export const getCarrierName = (obj, value) => {
  return Object.keys(obj).find((key) => obj[key] === value) || null;
};

export const statusList = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" }
];
